type Dependencie = () => Promise<void>;

class GlobalRefresh {
  static dependencies: Array<Dependencie> = [];

  static collectDependencie(dependencie: Dependencie) {
    GlobalRefresh.dependencies.some((d) => d.toString() === dependencie.toString()) ||
      GlobalRefresh.dependencies.push(dependencie);
  }

  static triggerDependencies() {
    return Promise.all(GlobalRefresh.dependencies.map((d) => d()));
  }

  static removeDependencie(dependencie?: Dependencie): boolean {
    if (!dependencie) {
      GlobalRefresh.dependencies = [];
      return true;
    }

    const target = GlobalRefresh.dependencies.findIndex(
      (d) => d.toString() === dependencie.toString(),
    );

    if (target > -1) {
      GlobalRefresh.dependencies.splice(target, 1);
      return true;
    }
    return false;
  }
}

export default GlobalRefresh;
